import { DatePipe } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ISurveyors } from "app/models/core/admin/surveyors";
import { IKey, Keys } from "app/models/core/keys";
import { IDeficiency, ISurvey } from "app/models/core/lab/surveys";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";




@Component({
  selector: 'app-surveys',
  templateUrl: './surveys.component.html',
  styleUrls: ['./surveys.component.scss']
})

export class SurveyComponent implements OnInit {
  @Input() stateNumber: string = '';

  list: ISurvey[] = [];
  editSurvey: ISurvey;
  deficiencies: IDeficiency[] = [];
  surveyorList: ISurveyors[] = [];
  surveyTypes: IKey[] = Keys.surveyType;

  displayedColumns: string[] = ['surveyId', 'surveyDate', 'surveyType', 'surveyors',
    'conditionLevel', 'followUpDue', 'followUpDone', 'onSiteFollowUp', 'deficiencies',
    'hoursOnSite', 'actions'
  ];
  dataSource = new MatTableDataSource<ISurvey>(this.list);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  deficiencyColumns: string[] = ['deficiencies', 'totalSod', 'totalPoc',
    'comments', 'actions'
  ];
  deficiencySource = new MatTableDataSource<IDeficiency>(this.deficiencies);
  @ViewChild('TableSort2') deficiencySort: MatSort;


  selectedLab = '';
  listFilter = '';
  editMode = 'list';
  sodCorrect = 0;
  pocCorrect = 0;
  sodDateGoal = '';
  pocDateToCompleted = '';
  totalDaysGoal = '';
  daysSodToPoc = '';
  daysToPacketReviewed = '';

  surveyFormGroup = new UntypedFormGroup({
    LabId: new UntypedFormControl(0),
    SurveyId: new UntypedFormControl(0),
    SurveyType: new UntypedFormControl('', [Validators.required]),
    HoursOnSite: new UntypedFormControl('', [Validators.maxLength(3)]),
    Deficiency: new UntypedFormControl('', [Validators.maxLength(2)]),
    OnSiteFollowUp: new UntypedFormControl(''),
    FollowUpDone: new UntypedFormControl(new Date()),
    ConditionLevel: new UntypedFormControl('', [Validators.maxLength(2)]),
    Surveyor1: new UntypedFormControl('', [Validators.maxLength(50)]),
    Surveyor2: new UntypedFormControl('', [Validators.maxLength(50)]),
    Surveyor3: new UntypedFormControl('', [Validators.maxLength(50)]),
    SurveyDate: new UntypedFormControl('', [Validators.required]),
    FollowUpDue: new UntypedFormControl(''),
    DateCreated: new UntypedFormControl(''),
    CreatedBy: new UntypedFormControl('', [Validators.maxLength(100)]),
    LastUpdated: new UntypedFormControl(''),
    UpdatedBy: new UntypedFormControl('', [Validators.maxLength(100)]),
    ScheduleDate: new UntypedFormControl(''),
    SodSentDate: new UntypedFormControl(''),
    PacketCompletedDate: new UntypedFormControl(''),
    PocReceivedDate: new UntypedFormControl(''),
    PacketReviewDate: new UntypedFormControl(''),
    SurveyorComments: new UntypedFormControl('', [Validators.maxLength(4000)]),
    QaReviewComments: new UntypedFormControl('', [Validators.maxLength(4000)]),
    SurveySod: new UntypedFormControl('', [Validators.maxLength(10)]),
    PocPacketCompleted: new UntypedFormControl(''),
    SodPoc: new UntypedFormControl('', [Validators.maxLength(10)]),
    PacketCompletedReceived: new UntypedFormControl('', [Validators.maxLength(10)]),
    SurveyProcess: new UntypedFormControl('', [Validators.maxLength(10)]),
    SurveyOutcomeOriented: new UntypedFormControl('', [Validators.maxLength(10)]),
    SodCorrect: new UntypedFormControl('', [Validators.maxLength(10)]),
    PocCorrect: new UntypedFormControl('', [Validators.maxLength(10)]),
    PercentSodCorrect: new UntypedFormControl('', [Validators.maxLength(10)]),
    PercentPocCorrect: new UntypedFormControl('', [Validators.maxLength(10)]),
    TotalVolume: new UntypedFormControl('', [Validators.maxLength(10)])
  });

  constructor(public labService: LabService,
    public sharedService: SharedService,
    public adminService: AdminService,
    private datePipe: DatePipe) { };

  ngOnInit() {
    if (this.labService.lab != null) {
      this.editMode = 'list';
      this.refreshData();
      this.adminService.getSurveyors().subscribe(
        res => {
          this.surveyorList = res;
        },
        error => console.log('error: ', error),
        () => { }
      );
    }
  }

  refreshData() {
    this.labService.getSurveys(this.labService.lab.labId.toString()).subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.labService.lab.lastSurveyDate = this.list != null && this.list.length > 0? this.list[0].surveyDate :'';
        this.editMode = 'list';
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  print(id:number) {
    id = id == 0? this.editSurvey.surveyId : id;
    this.labService.surveyReport(id).subscribe(
      response => {
        this.downloadFile("SurveyReport", response);
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  edit(surveyItem: ISurvey) {
    this.editSurvey = surveyItem;
    this.loadOrSaveFormData('load');
    this.deficiencies = surveyItem.deficienciesList;
    this.deficiencySource.data = surveyItem.deficienciesList;
    this.updateDaysCalculations();
    this.updatePocSodCalculations();
    this.editMode = 'edit';
  }

  add() {
    this.editSurvey = {
      labId: this.labService.lab.labId,
      surveyId: 0,
      surveyType: '',
      hoursOnSite: '',
      deficiency: '0',
      onSiteFollowUp: '',
      followUpDone: '',
      conditionLevel: '',
      surveyor1: '',
      surveyor2: '',
      surveyor3: '',
      surveyDate: '',
      followUpDue: '',
      dateCreated: '',
      createdBy: '',
      lastUpdated: '',
      updatedBy: '',
      scheduleDate: '',
      sodSentDate: '',
      packetCompletedDate: '',
      pocReceivedDate: '',
      packetReviewDate: '',
      surveyorComments: '',
      qaReviewComments: '',
      surveySod: '',
      pocPacketCompleted: '',
      sodPoc: '',
      packetCompletedReceived: '',
      surveyProcess: '',
      surveyOutcomeOriented: '',
      sodCorrect: '',
      pocCorrect: '',
      percentSodCorrect: '',
      percentPocCorrect: '',
      totalVolume: this.labService.totalVolume.toString(),
      deficienciesList: []
    };
    this.surveyFormGroup.reset();
    this.deficiencySource.data = [];
    this.loadOrSaveFormData('load');
    this.updateDaysCalculations();
    this.updatePocSodCalculations();
    this.editMode = 'add';
  }

  delete(surveyId: number) {
    if (!confirm('Delete this Survey? Continue?')) {
      return;
    }
    surveyId = surveyId == 0? this.editSurvey.surveyId: surveyId;

    this.labService.deleteSurvey(surveyId).subscribe(
      () => {
        this.refreshData();
      },
      error => console.log('error: ', error),
      () => { }
    );
  }

  save() {
    if (this.surveyFormGroup.valid) {
      this.loadOrSaveFormData('save');
      this.labService.saveSurvey(this.editSurvey).subscribe(
        () => {
          this.refreshData();
        },
        error => console.log('error: ', error),
        () => { }
      );
    }
  }

  cancel() {
    this.editMode = 'list';
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  addDeficiency() {
    let newDeficiency: IDeficiency = {
      defId: 0,
      surveyId: this.editSurvey.surveyId,
      poc: '',
      sod: '',
      deficiency: '',
      comments: '',
      selected: ''
    }
    if (this.editSurvey.deficienciesList == null) {
      this.editSurvey.deficienciesList = [newDeficiency];
    }
    else {
      this.editSurvey.deficienciesList.push(newDeficiency);
    }
    this.editSurvey.deficiency = this.editSurvey.deficienciesList != null ?
      this.editSurvey.deficienciesList.length.toString() : '0';
    this.deficiencySource.data = this.editSurvey.deficienciesList;
    this.updatePocSodCalculations();
    this.updateDeficiencyCount();
  }

  deleteDeficiency(def: IDeficiency) {
    if (this.editSurvey.deficienciesList != null) {
      let removeIndex = 0;
      this.editSurvey.deficienciesList.forEach(function (val: IDeficiency, index) {
        if (val.defId == def.defId && val.deficiency == def.deficiency && val.poc == def.poc
          && val.sod == def.sod && val.comments == def.comments) {
          removeIndex = index;
        }
      });
      this.editSurvey.deficienciesList.splice(removeIndex, 1)
      this.deficiencySource.data = this.editSurvey.deficienciesList;
      this.updatePocSodCalculations();
      this.updateDeficiencyCount();
    }
  }

  loadOrSaveFormData(action: string) {
    if (action == 'load') {
      this.surveyFormGroup.patchValue({
        LabId: this.editSurvey.labId,
        SurveyId: this.editSurvey.surveyId,
        SurveyType: this.editSurvey.surveyType,
        HoursOnSite: this.editSurvey.hoursOnSite,
        Deficiency: this.editSurvey.deficiency,
        OnSiteFollowUp: this.editSurvey.onSiteFollowUp,
        FollowUpDone: this.editSurvey.followUpDone == '' ? null : new Date(this.editSurvey.followUpDone),
        ConditionLevel: this.editSurvey.conditionLevel,
        Surveyor1: this.editSurvey.surveyor1,
        Surveyor2: this.editSurvey.surveyor2,
        Surveyor3: this.editSurvey.surveyor3,
        SurveyDate: new Date(this.editSurvey.surveyDate),
        FollowUpDue: this.editSurvey.followUpDue == '' ? null : new Date(this.editSurvey.followUpDue),
        DateCreated: this.editSurvey.dateCreated,
        CreatedBy: this.editSurvey.createdBy,
        LastUpdated: this.editSurvey.lastUpdated,
        UpdatedBy: this.editSurvey.updatedBy,
        ScheduleDate: this.editSurvey.scheduleDate == '' ? null : new Date(this.editSurvey.scheduleDate),
        SodSentDate: this.editSurvey.sodSentDate == '' ? null : new Date(this.editSurvey.sodSentDate),
        PacketCompletedDate: this.editSurvey.packetCompletedDate == '' ? null : new Date(this.editSurvey.packetCompletedDate),
        PocReceivedDate: this.editSurvey.pocReceivedDate == '' ? null : new Date(this.editSurvey.pocReceivedDate),
        PacketReviewDate: this.editSurvey.packetReviewDate == '' ? null : new Date(this.editSurvey.packetReviewDate),
        SurveyorComments: this.editSurvey.surveyorComments,
        QaReviewComments: this.editSurvey.qaReviewComments,
        SurveySod: this.editSurvey.surveySod,
        PocPacketCompleted: this.editSurvey.pocPacketCompleted,
        SodPoc: this.editSurvey.sodPoc,
        PacketCompletedReceived: this.editSurvey.packetCompletedReceived,
        SurveyProcess: this.editSurvey.surveyProcess,
        SurveyOutcomeOriented: this.editSurvey.surveyOutcomeOriented,
        SodCorrect: this.editSurvey.sodCorrect,
        PocCorrect: this.editSurvey.pocCorrect,
        PercentSodCorrect: this.editSurvey.percentSodCorrect,
        PercentPocCorrect: this.editSurvey.percentPocCorrect,
        TotalVolume: this.editSurvey.totalVolume
      });
      this.deficiencies = this.editSurvey.deficienciesList;
    }
    else {
      let form = this.surveyFormGroup.value;
      this.editSurvey = {
        labId: form.LabId,
        surveyId: form.SurveyId,
        surveyType: form.SurveyType,
        hoursOnSite: form.HoursOnSite,
        deficiency: form.Deficiency,
        onSiteFollowUp: form.OnSiteFollowUp,
        followUpDone: this.datePipe.transform(form.FollowUpDone, 'MM/dd/yyyy'),
        conditionLevel: form.ConditionLevel,
        surveyor1: form.Surveyor1,
        surveyor2: form.Surveyor2,
        surveyor3: form.Surveyor3,
        surveyDate: this.datePipe.transform(form.SurveyDate, 'MM/dd/yyyy'),
        followUpDue: this.datePipe.transform(form.FollowUpDue, 'MM/dd/yyyy'),
        dateCreated: form.DateCreated,
        createdBy: form.CreatedBy,
        lastUpdated: form.LastUpdated,
        updatedBy: form.UpdatedBy,
        scheduleDate: this.datePipe.transform(form.ScheduleDate, 'MM/dd/yyyy'),
        sodSentDate: this.datePipe.transform(form.SodSentDate, 'MM/dd/yyyy'),
        packetCompletedDate: this.datePipe.transform(form.PacketCompletedDate, 'MM/dd/yyyy'),
        pocReceivedDate: this.datePipe.transform(form.PocReceivedDate, 'MM/dd/yyyy'),
        packetReviewDate: this.datePipe.transform(form.PacketReviewDate, 'MM/dd/yyyy'),
        surveyorComments: form.SurveyorComments,
        qaReviewComments: form.QaReviewComments,
        surveySod: form.SurveySod,
        pocPacketCompleted: form.PocPacketCompleted,
        sodPoc: form.SodPoc,
        packetCompletedReceived: form.PacketCompletedReceived,
        surveyProcess: form.SurveyProcess,
        surveyOutcomeOriented: form.SurveyOutcomeOriented,
        sodCorrect: form.SodCorrect,
        pocCorrect: form.PocCorrect,
        percentSodCorrect: form.PercentSodCorrect,
        percentPocCorrect: form.PercentPocCorrect,
        totalVolume: form.TotalVolume,
        deficienciesList: this.editSurvey.deficienciesList
      }
    }

  }

  updateDeficiencyCount() {
    this.editSurvey.deficiency = this.editSurvey.deficienciesList != null ?
      this.editSurvey.deficienciesList.length.toString() : '0';
    this.surveyFormGroup.controls['Deficiency'].setValue(this.editSurvey.deficiency);
  }

  updatePocSodCalculations() {
    let pocTotal = 0;
    let sodTotal = 0;
    if (this.editSurvey != null && this.editSurvey.deficienciesList != null) {
      this.editSurvey.deficienciesList.forEach(function (val: IDeficiency) {
        pocTotal += val.poc == null ? 0 : +val.poc;
        sodTotal += val.sod == null ? 0 : +val.sod;
      });
      this.editSurvey.sodCorrect = (sodTotal / this.editSurvey.deficienciesList.length).toFixed(1);
      this.editSurvey.pocCorrect = (pocTotal / this.editSurvey.deficienciesList.length).toFixed(1);
    }
    else {
      this.editSurvey.sodCorrect = '0';
      this.editSurvey.pocCorrect = '0';
    }
    this.editSurvey.percentPocCorrect = this.editSurvey.pocCorrect;
    this.editSurvey.percentSodCorrect = this.editSurvey.sodCorrect;
  }

  updateDaysCalculations() {
    let millisecPerDay = (1000 * 3600 * 24);
    // # Days from Survey Date to SOD Date
    let localSurveyDate = this.surveyFormGroup.controls['SurveyDate'].value;
    let localSodDate = this.surveyFormGroup.controls['SodSentDate'].value;
    if (localSurveyDate != null && localSurveyDate != '' &&
      localSodDate != null && localSodDate != '') {
      this.sodDateGoal = ((localSodDate - localSurveyDate) / millisecPerDay).toFixed(0);
    }
    else {
      this.sodDateGoal = '';
    }

    // # Days from POC Received to Packet Completed
    let localPocReceived = this.surveyFormGroup.controls['PocReceivedDate'].value;
    let localPacketComplete = this.surveyFormGroup.controls['PacketCompletedDate'].value;
    if (localPocReceived != null && localPocReceived != '' &&
      localPacketComplete != null && localPacketComplete != '') {
      this.pocDateToCompleted = ((localPacketComplete - localPocReceived) / millisecPerDay).toFixed(0);
    }
    else {
      this.pocDateToCompleted = '';
    }

    // Total Days of Survey Process
    let localPacketUploaded = this.surveyFormGroup.controls['PacketReviewDate'].value;
    if (localSurveyDate != null && localSurveyDate != '' &&
      localPacketUploaded != null && localPacketUploaded != '') {
      this.totalDaysGoal = ((localPacketUploaded - localSurveyDate) / millisecPerDay).toFixed(0);
    }
    else {
      this.totalDaysGoal = '';
    }

    // # Days from SOD/Letter Sent to POC Received
    let localPocDate = this.surveyFormGroup.controls['PocReceivedDate'].value;
    if (localPocDate != null && localPocDate != '' &&
      localSodDate != null && localSodDate != '') {
      this.daysSodToPoc = ((localPocDate - localSodDate) / millisecPerDay).toFixed(0);
    }
    else {
      this.daysSodToPoc = '';
    }

    // # Days from Packet Completed to Reviewed
    if (localPacketUploaded != null && localPacketUploaded != '' &&
      localPacketComplete != null && localPacketComplete != '') {
      this.daysToPacketReviewed = ((localPacketUploaded - localPacketComplete) / millisecPerDay).toFixed(0);
    }
    else {
      this.daysToPacketReviewed = '';
    }

  }

}

